import { reset } from 'redux-form'

import {
  FORGOT_PASSWORD_RESET_RECEIVE,
  FORGOT_PASSWORD_RESET_FAILURE,
  FORGOT_PASSWORD_RESET_REQUEST,
} from './authProfile'

import {
  FORGOT_PASSWORD_PROFILE_RECEIVE,
} from './forgotPassword'

export const PRESERVE_PASSWORD_ON_TOGGLE = 'forgotPasswordResetForm/PRESERVE_PASSWORD_ON_TOGGLE'

const initialState = {
  fieldName: '',
  initialValues: {},
  isSubmitting: false
}

export const reducer = (state = initialState, action) => {
  let init = {...state.initialValues}
  switch (action.type) {
    case PRESERVE_PASSWORD_ON_TOGGLE:
      const fieldName = action.fieldName
      const value = action.value
      if (fieldName && value) {
        init = { ...init, [fieldName]: value }
      }
      return {
        ...state,
        initialValues: init,
        fieldName
      }
    case FORGOT_PASSWORD_PROFILE_RECEIVE:
      const userInfo = action.payload.data.item
      return {
        ...state,
        initialValues: {
          email: userInfo.email,
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          question: userInfo.recoveryQuestion
        }
      }
    case FORGOT_PASSWORD_RESET_REQUEST:
      let preservedField = state.fieldName
      if (preservedField) {
        delete init[preservedField]
      }
      return {
        ...state,
        isSubmitting: true,
        initialValues: init
      }
    case FORGOT_PASSWORD_RESET_RECEIVE:
    case FORGOT_PASSWORD_RESET_FAILURE:
      return {
        ...state,
        isSubmitting: false
      }
    default:
      return state
  }
}

export const resetForm = () => {
  return (dispatch) => {
    dispatch(reset('forgotPasswordResetForm'))
  }
}

export const preserveReduxFormValueOnToggle = (fieldName, value) => ({ type: PRESERVE_PASSWORD_ON_TOGGLE, fieldName, value })

export default reducer
